import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import newlogo from '../../assets/img/new-logo.png';
import OTPInput from '../../elements/OtpInput';

class Verify2FAPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verificationCode: '',
        };
    }


    handleSubmitForm = async () => {
        const { authStore } = this.props;
        const { verificationCode } = this.state;

        try {
            await authStore.loginWith2FAVerificationCode(verificationCode);
            window.sessionStorage.removeItem('x-1fa-token');

            const lastPage = sessionStorage.getItem('lastPage');
            if (lastPage) {
                sessionStorage.removeItem('lastPage');
                this.props.router.navigate(lastPage);
            } else {
                this.props.router.navigate('/admin');
            }

        } catch (error) {
            console.error(error);
        }
    };

    render() {
        if (!window.sessionStorage.getItem('x-1fa-token')) {
            return <Navigate to="/login" replace />;
        }

        const { t } = this.props;
        const { verificationCode } = this.state;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Two-Factor Authentication').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        <p className="forogottext mb-3">
                            {t('Enter the verification code from authenticator app')}.
                        </p>
                        <div className="login-container twofa-verify-layout">
                            <label className="fw-bold mb-2">{t('Verification Code')}<span className="red-star">*</span></label>
                            <OTPInput
                                length={6}
                                type="number"
                                autoFocus
                                onChange={(code) => this.setState({ verificationCode: code })}
                                onSubmit={this.handleSubmitForm}
                                t={t}
                            />
                            <button
                                className="btn btn-block fwBold fs18 loginbutton mt-3"
                                onClick={this.handleSubmitForm}
                            >
                                {t('Verify')}
                            </button>
                        </div>
                        <div className="d-flex w-100 justify-content-between mt-3 mb-3">
                            <button
                                className="fs18 loginFooter border-none"
                                onClick={() => this.props.router.navigate('/login')}
                            >
                                {t('Back to login')}
                            </button>
                            <button
                                className="fs18 loginFooter border-none"
                                onClick={() => this.props.router.navigate('/login/recover-2fa')}
                            >
                                {t('Recover')} {t('2FA')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore')(applicationRouter(withLocalization(observer(Verify2FAPage))));
